import React from 'react';
import PwaHeaderStripExpanded from 'MMT-UI/PwaHeaderStripExpanded';
import { useState } from 'react';
import { APP_DOWNLOAD_BANNER } from '../../utils/RailsSEOConstants';
import { AppDownloadBannerPropsType } from '../types';

const AppDownloadBanner = ({ language }: AppDownloadBannerPropsType) => {
  const [showDownloadBanner, setShowDownloadBanner] = useState(true);
  const isEngish = language === APP_DOWNLOAD_BANNER.english;

  const englishData = {
    openAppData: {
      text: APP_DOWNLOAD_BANNER.englishHeader,
      subtext: APP_DOWNLOAD_BANNER.englishSubHeader,
      cta: {
        text: APP_DOWNLOAD_BANNER.englishOpenApp,
        deeplink: APP_DOWNLOAD_BANNER.appLink
      }
    },
    installAppData: {
      text: APP_DOWNLOAD_BANNER.englishHeader,
      subtext: APP_DOWNLOAD_BANNER.englishSubHeader,
      cta: {
        text: APP_DOWNLOAD_BANNER.englishInstallApp,
        deeplink: APP_DOWNLOAD_BANNER.appLink
      }
    }
  };

  const hindiData = {
    openAppData: {
      text: APP_DOWNLOAD_BANNER.hindiHeader,
      subtext: APP_DOWNLOAD_BANNER.hindiSubHeader,
      cta: {
        text: APP_DOWNLOAD_BANNER.hindiOpenApp,
        deeplink: APP_DOWNLOAD_BANNER.appLink
      }
    },
    installAppData: {
      text: APP_DOWNLOAD_BANNER.hindiHeader,
      subtext: APP_DOWNLOAD_BANNER.hindiSubHeader,
      cta: {
        text: APP_DOWNLOAD_BANNER.hindiInstallApp,
        deeplink: APP_DOWNLOAD_BANNER.appLink
      }
    }
  };
  const data = isEngish ? englishData : hindiData;
  const omnitureData = {
    onShownEvent: APP_DOWNLOAD_BANNER.omnitureShownEvent,
    onCtaClickEvent: APP_DOWNLOAD_BANNER.omnitureClickEvent
  };

  function onCloseExpandedStripClicked() {
    setShowDownloadBanner(false);
  }

  return (
    <div className="mobileShow">
      {showDownloadBanner && (
        <PwaHeaderStripExpanded data={data} onCloseClicked={onCloseExpandedStripClicked} omnitureData={omnitureData} />
      )}
    </div>
  );
};

export default AppDownloadBanner;
